export const getURLWithParams = (url, options) => {
    const { queryParams = {} } = options ?? {};
    const hasParams = url.indexOf('?') !== -1;
    let paramsQueryString =
        typeof queryParams === 'string'
            ? queryParams
            : new URLSearchParams(queryParams).toString();

    let urlWithParams = url;

    if (paramsQueryString) {
        if (
            paramsQueryString.indexOf('?') === 0 ||
            paramsQueryString.indexOf('&') === 0
        ) {
            paramsQueryString = paramsQueryString.substring(1);
        }

        urlWithParams = queryParams
            ? `${url}${hasParams ? '&' : '?'}${paramsQueryString}`
            : url;
    }

    return urlWithParams;
};

export const getRequestBody = (options) => {
    let bodyToSend;
    const { headers = {}, body } = options ?? {};

    if (body instanceof FormData) {
        headers['Content-Type'] = undefined;
        delete headers['Content-Type'];
        bodyToSend = body;
    } else if (body) {
        headers['Content-Type'] = 'application/json; charset=UTF-8';
        bodyToSend = typeof body === 'string' ? body : JSON.stringify(body);
    }

    return bodyToSend;
};

export default {};
